// Logotipo real de Grupo Dimoauto (petición 13-ago): el mismo /logotipo.png
// que usan las demás aplicaciones del grupo (hub-crm, centro-apps, costes-app…),
// en lugar del rótulo en texto «GRUPO DIMOAUTO · Concesionarios oficiales».
export function Marca({ height = 40, center = false }) {
  return (
    <div style={{
      height, display: "flex", alignItems: "center",
      justifyContent: center ? "center" : "flex-start", userSelect: "none",
    }}>
      <img src="/logotipo.png" alt="Dimoauto"
        style={{ height: Math.round(height * 0.72), width: "auto", maxWidth: "100%", display: "block", objectFit: "contain" }} />
    </div>
  );
}

export default Marca;
